import "./index.less";
import { DefaultComponentProps, ExtraAndDefaultSizes, FontWeight, Typography } from "../../../internal";
import { observer } from "mobx-react";
import React from "react";
import cn from "classnames";

export interface IAtParagraphProps extends DefaultComponentProps {
    lineHeight?: ExtraAndDefaultSizes;
    size?: ExtraAndDefaultSizes;
    weight?: FontWeight;
}

export const AtParagraph: React.FC<IAtParagraphProps> = observer((props) => {
    const { lineHeight = "md", size = "md", weight = "regular", className, style, id, children, ...otherProps } = props;

    const getStyles: () => React.CSSProperties = () => {
        let lineHeightValue: number;

        switch (lineHeight) {
            case "xs":
                lineHeightValue = 16;
                break;
            case "sm":
                lineHeightValue = 18;
                break;
            case "md":
                lineHeightValue = 22;
                break;
            case "lg":
                lineHeightValue = 24;
                break;
            case "xl":
                lineHeightValue = 28;
                break;
        }

        return {
            fontSize: Typography.getFontSizePropValue(size),
            fontWeight: Typography.getFontWeightPropValue(weight),
            lineHeight: `${lineHeightValue}px`,
            ...style,
        };
    };

    return (
        <p className={cn("AtParagraph", className)} id={id} style={getStyles()} {...otherProps}>
            {children}
        </p>
    );
});
